import React, { useState, useEffect } from "react";
import { Avatar, Typography, Popover } from "antd";
import styled from "styled-components";
import { getFullName } from "../util/helpers";
import { useLanguages } from "../../hooks";
import { useIntl } from "react-intl";
const { Title, Text } = Typography;

const PatientWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const PatientBrief = (props) => {
  const { patient } = props;
  const [list, setList] = useState([]);
  const intl = useIntl();
  const languages = useLanguages();
  useEffect(() => {
    if (list.length === 0 && languages && languages.length > 0) {
      setList(languages);
    }
  }, [languages]);

  const languagesNames =
    patient.languages && patient.languages.length > 0
      ? list
          .filter((i) => patient.languages.includes(i.id))
          .map((j) => j.name)
          .join(", ")
      : "";
  const letter = patient.first_name.charAt(0);
  let name = getFullName(patient.surename, patient.first_name);
  const content = <Text>{languagesNames}</Text>;
  return (
    <Popover
      placement="bottom"
      title={intl.formatMessage({
        id: "app.forms.patient.languages",
      })}
      content={content}
      trigger="hover"
    >
      <PatientWrapper>
        {patient.avatar_url ? (
          <Avatar src={patient.avatar_url} />
        ) : (
          <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
            {letter}
          </Avatar>
        )}
        <Title level={4} style={{ margin: "0", padding: "0 10px" }}>
          {name}
        </Title>
      </PatientWrapper>
    </Popover>
  );
};

export default PatientBrief;
